import { createSelector } from '@reduxjs/toolkit';
import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import { functionsNotDeleted } from './functions-not-deleted';

export const functionsNotDeletedByUuid = createSelector(
  functionsNotDeleted,
  (functions): Map<string, FunctionViewModel> => {
    const map = new Map<string, FunctionViewModel>();
    for (const f of functions) {
      map.set(f.uuid, f);
    }
    return map;
  },
);
